var COMPATIBILITY_GUIDE_API_CONFIG = {
    baseUrl: '',
    marketLocale: '',
};
export var getCompatibilityGuideApiConfig = function () {
    return COMPATIBILITY_GUIDE_API_CONFIG;
};
export var setCompatibilityGuideApiConfig = function (config) {
    COMPATIBILITY_GUIDE_API_CONFIG.baseUrl = config.baseUrl;
    COMPATIBILITY_GUIDE_API_CONFIG.marketLocale = config.marketLocale;
};
